// Single source of truth for the GoodHabits Family FAQ.
// Used by both the Help page and the home page FAQ section.
export const FAQS = [
  {
    q: 'How do I download my products?',
    a: "After completing your purchase, you'll receive an email with download links. You can also access your downloads from the order confirmation page. All products are available for instant download as printable PDFs.",
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept all major credit cards (Visa, Mastercard, American Express) through our secure Stripe payment system. All transactions are encrypted, and we never see or store your card details.',
  },
  {
    q: 'What is your policy on digital products?',
    a: "Due to the nature of digital downloads, all sales are final. If you experience any technical issues accessing your files, please contact our support team and we will ensure you receive the correct downloads.",
  },
  {
    q: 'How do I print the resources?',
    a: 'All PDFs are designed to print at home on standard US Letter (8.5×11") or A4 paper. Use a color printer for the best result, but most pages also read well in black and white.',
  },
  {
    q: 'Do you offer bundle discounts?',
    a: 'Yes — our pre-built bundles save 20–64%, and our Bundle Builder lets you assemble any 3+ products with up to 25% off automatically. The more you add, the more you save.',
  },
  {
    q: 'Are the resources research-backed?',
    a: 'Every guide is built in consultation with parenting experts, child psychologists, and educators. We cite peer-reviewed research on sleep, emotional regulation, screen time, and child development inside each product.',
  },
  {
    q: 'What ages are these for?',
    a: 'Most resources are designed for families with children ages 2–10, with specific products tuned for toddlers (2–4), preschoolers (4–6), and school-aged children (6–10). Each product page lists the recommended age range.',
  },
  {
    q: 'How often do you release new products?',
    a: 'We ship new resources monthly, based on parent feedback and emerging research. Subscribe to the newsletter at the bottom of the page to be the first to hear about new releases (and get early-bird discounts).',
  },
];
